import { render, staticRenderFns } from "./ReviewHealthPlan.vue?vue&type=template&id=58146ee8&scoped=true"
import script from "./ReviewHealthPlan.vue?vue&type=script&lang=ts"
export * from "./ReviewHealthPlan.vue?vue&type=script&lang=ts"
import style0 from "./ReviewHealthPlan.vue?vue&type=style&index=0&id=58146ee8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58146ee8",
  null
  
)

export default component.exports